import { render } from "./the-global-error.vue?vue&type=template&id=921b98c4&ts=true"
import script from "./the-global-error.vue?vue&type=script&lang=ts"
export * from "./the-global-error.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__